export default "__VITE_ASSET__6SIuVHIt__"